import { render, staticRenderFns } from "./deliverManage.vue?vue&type=template&id=292bca51&scoped=true&"
import script from "./deliverManage.vue?vue&type=script&lang=js&"
export * from "./deliverManage.vue?vue&type=script&lang=js&"
import style0 from "./deliverManage.vue?vue&type=style&index=0&id=292bca51&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "292bca51",
  null
  
)

export default component.exports